import {Injectable} from '@angular/core';
import {Event as RouterEvent, Router, RoutesRecognized} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, pairwise, share, startWith, takeUntil} from 'rxjs/operators';

type RouteChange = [RoutesRecognized, RoutesRecognized];

@Injectable()
export class RouteChangesService {

    public get previousRoute(): RoutesRecognized {
        return this._previousRoute;
    }

    public get nextRoute(): RoutesRecognized {
        return this._nextRoute;
    }

    public routeChanges$: Observable<RouteChange>;

    private _previousRoute: RoutesRecognized = null;
    private _nextRoute: RoutesRecognized = null;

    constructor(
        private router: Router
    ) {}

    public init(dispose$: Observable<any>): void {
        this.routeChanges$ = this.router.events.pipe(
            filter((event: RouterEvent): event is RoutesRecognized => event instanceof RoutesRecognized),
            startWith(null),
            pairwise(),
            map(([previousRoute, nextRoute]) => {
                this._previousRoute = previousRoute;
                this._nextRoute = nextRoute;

                return [previousRoute, nextRoute] as RouteChange;
            }),
            takeUntil(dispose$),
            share()
        );

        this.routeChanges$.subscribe();
    }

}
